<template >
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
               label-width="80px">
        <el-form-item label="类型"  prop="type">
          <el-radio-group @change="typeChange" style="" v-model="dataForm.type">
            <el-radio v-for="(type, index) in dataForm.typeList" :label="index" :key="index">{{ type }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="dataForm.typeList[dataForm.type] + '名称'" prop="name">
          <el-input v-model="dataForm.name" :placeholder="dataForm.typeList[dataForm.type] + '名称'"></el-input>
        </el-form-item>
        <el-form-item label="上级菜单" prop="parentName">

            <el-popover
                    ref="menuListPopover"
                    placement="top-start"
                    trigger="click"
            >
              <el-tree
                      :data="menuList"
                      :props="menuListTreeProps"
                      node-key="menuId"
                      ref="menuListTree"
                      @current-change="menuListTreeCurrentChangeHandle"
                      :default-expand-all="true"
                      :highlight-current="true"
                      :expand-on-click-node="false">
              </el-tree>
            </el-popover>

          <el-input v-model="dataForm.parentName" v-popover:menuListPopover :readonly="true" placeholder="点击选择上级菜单"
                    class="menu-list__input"></el-input>
        </el-form-item>

        <el-form-item v-show="dataForm.type === 1" label="菜单路由" prop="url">
          <el-input v-model="dataForm.url" placeholder="菜单路由"></el-input>
        </el-form-item>
        <el-form-item v-show="dataForm.type === 1" label="组件目录" prop="component">
          <el-input v-model="dataForm.component" placeholder="组件目录"></el-input>
        </el-form-item>
        <el-form-item v-show="dataForm.type === 1" label="KeepAlive" prop="KeepAlive">
          <el-switch v-model="dataForm.keepAlive"  :active-value="1"
                     :inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item v-show="dataForm.type === 1" label="单独打开" prop="openAlone">
          <el-switch v-model="dataForm.openAlone"  :active-value="1"
                     :inactive-value="0"></el-switch>
        </el-form-item>
<!--        <el-form-item  v-show="dataForm.type === 0" label="图标" prop="icon">-->
<!--          <el-input v-model="dataForm.icon" :placeholder="'请输入图标'"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="图标" prop="icon">
          <el-input v-model="dataForm.icon" :placeholder="'请输入图标'"></el-input>
        </el-form-item>
        <el-form-item  v-show="dataForm.type === 2" label="授权标识" prop="permission">
          <el-input v-model="dataForm.permission" :placeholder="'请输入授权标识'"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="orderNum">
          <el-input-number style="" v-model="dataForm.orderNum" controls-position="right" :min="0" label="排序号"></el-input-number>
        </el-form-item>


      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      const validateUrl = (rule, value, callback) => {
        if (this.dataForm.type === 1 && !/\S/.test(value)) {
          callback(new Error('菜单URL不能为空'))
        } else {
          callback()
        }
      }
      const validateComponent = (rule, value, callback) => {
        if (this.dataForm.type === 1 && !/\S/.test(value)) {
          callback(new Error('组件目录不能为空'))
        } else {
          callback()
        }
      }
      const validatePermission = (rule, value, callback) => {
        if (this.dataForm.type === 2 && !/\S/.test(value)) {
          callback(new Error('授权标识不能为空'))
        } else {
          callback()
        }
      }
      return {
        visible: false,
        dataForm: {

          id: 0,
          type: 0,
          typeList: ['目录', '菜单','按钮'],
          name: '',
          parentId: 0,
          parentName: '',
          url: '',
          perms: '',
          orderNum: 0,
          icon: '',
          keepAlive:0,
          openAlone:0,
          component:'',
          permission:''
        },
        dataRule: {
          name: [
            {required: true, message: '菜单名称不能为空', trigger: 'blur'}
          ],
          parentName: [
            {required: true, message: '上级菜单不能为空', trigger: 'change'}
          ],
          permission: [ {validator: validatePermission, trigger: 'blur'}],
          url: [
            {validator: validateUrl, trigger: 'blur'}
          ],
          component: [
            {validator: validateComponent, trigger: 'blur'}
          ]
        },
        menuList: [],
        menuListTreeProps: {
          label: 'name',
          children: 'children'
        }
      }
    },
    created () {

    },
    methods: {
      typeChange(val) {

      },
      init (id) {
        this.dataForm.id = id || 0
        this.$http({
          url: '/bjba/sys/menu/select',
          method: 'get'
        }).then(({data}) => {
          this.menuList = this.treeDataTranslate(data.data, 'menuId')
        }).then(() => {
          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
          })
        }).then(() => {
          if (!this.dataForm.id) {
            // 新增
            this.menuListTreeSetCurrentNode()
          } else {
            // 修改
            this.$http({
              url: `/bjba/sys/menu/info/${this.dataForm.id}`,
              method: 'get'
            }).then(({data}) => {
              console.log('2222222222')
              this.dataForm.id = data.data.menuId
              this.dataForm.type = data.data.type
              this.dataForm.name = data.data.name
              this.dataForm.parentId = data.data.parentId
              this.dataForm.url = data.data.url
              this.dataForm.perms = data.data.perms
              this.dataForm.orderNum = data.data.ordernum
              this.dataForm.icon = data.data.icon
              this.dataForm.component = data.data.component
              this.dataForm.keepAlive = data.data.keepAlive
              this.dataForm.openAlone = data.data.openAlone
              this.dataForm.permission = data.data.permission
              this.menuListTreeSetCurrentNode('mod')
            })
          }
        })
      },
      // 菜单树选中
      menuListTreeCurrentChangeHandle (data, node) {
        this.dataForm.parentId = data.menuId
        this.dataForm.parentName = data.name
      },
      // 菜单树设置当前选中节点
      menuListTreeSetCurrentNode (type) {
        if (type === 'mod') {
          this.$refs.menuListTree.setCurrentKey(this.dataForm.parentId)
          this.dataForm.parentName = (this.$refs.menuListTree.getCurrentNode() || {})['name']
        }
      },
      // 表单提交
      dataFormSubmit () {
        if(this.dataForm.type==0) {
          this.dataForm.url=''
          this.dataForm.keepAlive=0
          this.dataForm.openAlone=0
          this.dataForm.component=''
          this.dataForm.permission=''
        } else if(this.dataForm.type==1) {
          // this.dataForm.icon=''
          this.dataForm.permission=''
        } else if(this.dataForm.type==2) {
          this.dataForm.url=''
          this.dataForm.keepAlive=0
          this.dataForm.openAlone=0
          this.dataForm.component=''
          this.dataForm.icon=''
        }
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/bjba/sys/menu/save`,
              method: 'post',
              data: {
                'menuId': this.dataForm.id || undefined,
                'type': this.dataForm.type,
                'name': this.dataForm.name,
                'parentId': this.dataForm.parentId,
                'url': this.dataForm.url,
                'perms': this.dataForm.perms,
                'ordernum': this.dataForm.orderNum,
                'icon': this.dataForm.icon,
                'keepAlive': this.dataForm.keepAlive,
                'openAlone': this.dataForm.openAlone,
                'component': this.dataForm.component,
                'permission':this.dataForm.permission
              }
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500
                })
                this.visible = false
                this.$emit('refreshDataList')
              }else if(data && data.code === 500) {
                this.$message({
                  message: data.message,
                  type: "error",
                  duration: 1500
                })
              }
            })
          }
        })
      },
      /**
       * 树形数据转换
       * @param {*} data list数据
       * @param {*} id 主键ID
       * @param {*} pid 上级ID
       * @param childrenKey 子list数据的key
       */
        treeDataTranslate (data, id = 'id', pid = 'parentId', childrenKey = 'children') {
        let res = []
        let temp = {}
        for (let i = 0; i < data.length; i++) {
          temp[data[i][id]] = data[i]
        }
        for (let k = 0; k < data.length; k++) {
          if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
            if (!temp[data[k][pid]][childrenKey]) {
              temp[data[k][pid]][childrenKey] = []
            }
            if (!temp[data[k][pid]]['_level']) {
              temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            temp[data[k][pid]][childrenKey].push(data[k])
          } else {
            res.push(data[k])
          }
        }
        return res
      }

    }
  }
</script>

<style lang="scss" >
  .el-popper {
    max-height: 500px;
    /*max-width: 200px;*/
    overflow-x: hidden;
    overflow-y: auto;
  }
  #left .el-form-item__content{
    text-align: left;
  }
  .menu-list__input,
  .icon-list__input {

    > .el-input__inner {
      cursor: pointer;
    }

  }

  .mod-menu__icon-popover {
    max-width: 350px;
  }

  .mod-menu__icon-list {
    max-height: 380px;
    padding: 0;
    margin: -8px 0 0 -8px;

    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;

      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }

    }
  }

  .icon-list__tips {
    font-size: 18px;
    text-align: center;
    color: #e6a23c;
    cursor: pointer;
  }
</style>
